jQuery(document).ready(function($){
  if($('.o-minimal-post-carousel')[0]){
    $('.o-minimal-post-carousel').each(function() {
      $(this).find('.o-minimal-post-carousel__list').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        variableWidth: true,
        appendArrows: $(this).find('.o-minimal-post-carousel__arrows'),
        responsive: [
          {
              breakpoint: 1024,
              settings: {
                  slidesToShow: 3,
              }
          },
          {
              breakpoint: 768,
              settings: {
                  slidesToShow: 2,
              }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              variableWidth: false,
            }
          }
        ]
      })
    });
  }
});